"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayJournalType = exports.displayNsStatusName = exports.JEAPP_PREFIX = void 0;
exports.JEAPP_PREFIX = "JEAPP";
function displayNsStatusName(statusName) {
    const raw = String(statusName || "").trim();
    if (!raw)
        return "";
    const colon = raw.indexOf(":");
    if (colon < 0)
        return raw;
    return raw.slice(colon + 1).trim() || raw;
}
exports.displayNsStatusName = displayNsStatusName;
function displayJournalType(recordType, recordTypeLabel) {
    const type = String(recordType || "").trim().toLowerCase();
    const label = String(recordTypeLabel || "").trim();
    const combined = `${type} ${label}`.toLowerCase();
    if (type === "advintercompanyjournalentry" ||
        combined.includes("advintercompany") ||
        combined.includes("advanced intercompany") ||
        /\baije\b/.test(combined)) {
        return "AIJE";
    }
    if (type === "journalentry" || /^journal$/i.test(label)) {
        return "Journal";
    }
    return label || recordType || "";
}
exports.displayJournalType = displayJournalType;
